import {
  SEND_BRIEF_ALL,
} from './constants';

export function sendBriefAll(data) {
  return {
    type: SEND_BRIEF_ALL,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/send-brief-all-modal/actions.js
 **/